'use client';
import React from 'react';
import { useCertificates } from '@/contexts/CertificatesContext';
import { Archive, FileCheck, HelpCircle, XCircle, Clock } from 'lucide-react';
import { computeCertificateHealth } from '@/lib/certificate-alerts';

export default function KpiCards() {
  const { certificates } = useCertificates();
  const health = computeCertificateHealth(certificates);

  const cards = [
    {
      id: 'kpi-valid',
      label: 'Valid',
      value: health.valid,
      icon: FileCheck,
      colorClass: 'text-[color:var(--status-valid)]',
      bgStyle: { backgroundColor: 'var(--status-valid-bg)' },
    },
    {
      id: 'kpi-expiring',
      label: 'Expiring Soon',
      value: health.expiringSoon,
      icon: Clock,
      colorClass: 'text-[color:var(--status-expiring-soon)]',
      bgStyle: { backgroundColor: 'var(--status-expiring-soon-bg)' },
    },
    {
      id: 'kpi-expired',
      label: 'Expired',
      value: health.expired,
      icon: XCircle,
      colorClass: 'text-[color:var(--status-critical)]',
      bgStyle: { backgroundColor: 'var(--status-critical-bg)' },
    },
    {
      id: 'kpi-review',
      label: 'Verify Requirement',
      value: health.review,
      icon: HelpCircle,
      colorClass: 'text-primary',
      bgClass: 'bg-secondary',
    },
    {
      id: 'kpi-covered',
      label: 'Covered Historical',
      value: health.coveredHistorical,
      icon: Archive,
      colorClass: 'text-muted-foreground',
      bgClass: 'bg-muted',
    },
  ];

  return (
    <section aria-labelledby="certificate-health-heading">
      <div className="flex items-baseline justify-between gap-3 mb-2">
        <h2 id="certificate-health-heading" className="text-sm font-700 text-foreground">
          Certificate Health Overview
        </h2>
        <p className="text-xs text-muted-foreground">{certificates.length} tracked</p>
      </div>
      <p className="mb-3 text-xs text-muted-foreground">
        Valid: {health.valid} · Expired: {health.expired} · Verification Required: {health.review} · Covered Historical: {health.coveredHistorical}
      </p>
      <div className="kpi-grid grid grid-cols-2 lg:grid-cols-5 gap-3">
        {cards.map((card) => (
          <div key={card.id} className="kpi-card card-elevated card-hover p-4" style={(card as any).bgStyle}>
            <div
              className={`kpi-icon w-8 h-8 rounded-lg flex items-center justify-center shrink-0 mb-3 ${(card as any).bgClass || ''}`}
              style={!(card as any).bgClass ? { backgroundColor: 'rgba(255,255,255,0.6)' } : undefined}
            >
              <card.icon size={16} className={card.colorClass} />
            </div>
            <p className={`text-2xl font-800 font-tabular ${card.colorClass}`}>{card.value}</p>
            <p className="text-xs font-500 text-muted-foreground mt-1 leading-snug">{card.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
